// extracted by css-extract-rspack-plugin
export default {"items":"_996c3b05","linkImage":"_981b6d84","item":"_6d740f36","image":"_cf03dd64"};